import {
  GroupProps as MantineGroupProps,
  Group as MantineGroup,
} from '@mantine/core';

export type GroupProps = MantineGroupProps;

export const Group = MantineGroup;

Group.displayName = 'Group';
